import React from "react";

import { getReadableOrgTiers } from "utils/organization";

import MultiSelectFilter from "./MultiSelectFilter";

import type { FC } from "react";
import type { ReadableOrgTier } from "utils/organization";
import type { BaseProps } from "./SelectFilter";

interface Props extends BaseProps {
  placeholder: string;
  onSelect: (value: string[]) => void;
  selectedValues?: string[] | undefined;
  convertParamVariable?: (tiers: string) => string[];
  disabled?: boolean;
}

// TODO (david.taylor): we should refactor this to use Rivet UI select
const MultiOrgTierFilter: FC<Props> = ({
  onSelect,
  convertParamVariable,
  placeholder,
  className,
  style,
  paramKey,
  disabled = false,
  selectedValues = undefined,
}) => {
  return (
    <MultiSelectFilter<ReadableOrgTier, string>
      onSelect={onSelect}
      className={className}
      style={style}
      disabled={disabled}
      placeholder={placeholder}
      data={getReadableOrgTiers()}
      paramKey={paramKey}
      getKey={tier => tier.readableName}
      getValue={tier => tier.enumStringName}
      getTitle={tier => tier.readableName}
      convertParamVariable={convertParamVariable}
      showSearch={false}
      setValue={selectedValues}
    />
  );
};

export default MultiOrgTierFilter;
